export default "__VITE_ASSET__B0Pqsrm2__"